<template>
  <button
    :class="
      `ml-1 box-border h-10 bg-white border-4 border-${color} disabled:opacity-50 disabled:bg-black`
    "
    style="width:180px;"
    type="button"
    v-bind="$attrs"
  >
    <div class="flex flex-row items-center justify-center">
      <svg
        width="20"
        height="20"
        viewBox="0 0 22 22"
        fill="white"
        xmlns="http://www.w3.org/2000/svg"
        class="mr-1"
      >
        <circle cx="11" cy="11" r="10.5" stroke="#549a1d" fill="#549a1d" />
        <path
          d="M15 4.07175C14.0434 3.51947 12.8202 3.84722 12.2679 4.8038L7.76793 12.598L11.232 14.598L15.732 6.8038C16.2843 5.84722 15.9566 4.62403 15 4.07175Z"
        />
        <path
          d="M7.48232 18.0212C7.12762 18.3003 6.61387 18.0037 6.67824 17.557L7.26793 13.4641L10.732 15.4641L7.48232 18.0212Z"
        />
      </svg>
      <div class="flex flex-row items-baseline">
        <span :class="`text-${color} text-lg font-bold leading-tight`">
          修正
        </span>
        <span :class="`text-${color} text-sm font-bold leading-tight`"
          >する
        </span>
      </div>
    </div>
  </button>
</template>

<script>
export default {
  name: 'AppReceiptShowFormBtn',

  props: {
    color: String,
  },
}
</script>

<style lang="scss" scoped>
button {
  border-radius: 20px;
  width: 512px;
  &:disabled {
    div {
      svg {
        fill: black;
        circle {
          fill: #549a1d;
        }
      }
    }
  }
}
</style>
